/**
 * shareParam  公共接口的国际化国际化
 * date：2022 04 19
 */
export default {
  public: {
    // 客户状态
    customer_status_cancel: '注销',
    customer_status_active: '激活',
    // 用户状态
    user_status_cancel: '注销',
    user_status_activity: '激活',
    // 角色状态
    role_status_cancel: '注销',
    role_status_activity: '激活',

    // 客户类型
    customer_type_platform: '平台',
    customer_type_noplatform: '企业',

    is_platform: '平台',
    not_platform: '企业',

    // 用户类型
    user_type_default: '默认用户',
    user_type_nodefault: '非默认用户',

    // 账号类型
    account_type_default: '默认账号',
    account_type_nodefault: '非默认账号',

    // 角色类型
    role_type_platform: '平台角色',
    role_type_noplatform: '非平台角色',

    // 角色类型
    role_type_default: '默认角色',
    role_type_nodefault: '非默认角色',

    customer_org_type_00: '疾控',
    customer_org_type_01: '社区医院',
    customer_org_type_02: '综合医院',
    customer_org_type_03: '儿童医院',
    customer_org_type_04: '妇幼保健院',
    customer_org_type_05: '民营医疗机构',
    customer_org_type_09: '其他',
    please: '请选择',
    // 角色类型
    role_customer_proxy: '代理管理',
    role_customer_nomal: '企业使用',
    role_customer_admin: '企业管理',
    role_platform_normal: '平台使用',
    role_platform_admin: '平台管理',

    // 客户
    All: '全部',
    Proxy: '代理角色',
    start_time: '开始时间',
    end_time: '结束时间',
    details: '详情',
    detail: '详细',
    phone_num: '手机号码',

    // 等级
    level_0: '等级0',
    level_1: '等级1',
    level_2: '等级2',
    level_3: '等级3',
    level_4: '等级4',

    // 模式
    mode_view: '查阅模式',
    mode_edit: '编辑模式',

    // 等级对应的角色
    level_0_role:
      '客户使用用户/客户管理用户/代理管理用户/平台使用用户/平台管理用户/Root用户',
    level_1_role:
      '客户管理用户/代理管理用户/平台使用用户/平台管理用户/Root用户',
    level_2_role: '平台使用用户/平台管理用户/Root用户',
    level_3_role: '平台管理用户/Root用户',
    level_4_role: 'Root用户',

    // 公用
    prompt: '提示',
    least_one_data: '请选择至少一条数据',
    no_data: '暂无数据',
    no_more: '没有更多了',
    please_enter: '请输入',
    fail: '失败',
    success: '成功',
    system_error: '系统错误',
    email: '电子邮箱',
    emailbox: '电子邮箱',
    wechat: '微信',
    blog: '微博',
    edit: '编辑',
    sensor: '传感器',
    gateway: '网关',
    display: '显示屏',
    relay: '中继',
    reuse: '重新使用',
    sample_value: '取样',
    net_param: '网络参数',
    escalation_rules: '上报规则',
    sound_light_alarm: '声光报警',
    gps_param: 'GPS参数',
    gateway_mac: '载体对应的网关MAC地址',
    process_time: '处理时间',

    status: '状态',
    time: '时间',
    Processed: '是否处理',
    type: '类型',
    op_type: '类型',
    op_time: '时间',
    save: '保存',
    saveImpl: '保存并执行',
    impl: '执行',
    choose: '选择',
    config_status: '配置状态',
    carrier: '资产',
    detail_info: '详细信息',
    location_title: '位置',
    group_title: '群组',
    belong: '组织架构',
    belong_customer: '企业',
    belong_arch: '组织架构',
    config: '配置',
    config_info: '配置信息',
    cancel: '取消',
    command: '命令',
    attribute: '属性',
    history_data: '历史数据',
    carrier_detail: '资产详情',
    carrier_type: '资产类型',
    carrier_status: '资产状态',
    alarm_switch: '报警开关',
    start_date: '开始日期',
    end_date: '结束日期',
    // start_time: '开始时间',
    // end_time: '结束时间',
    to: '至',
    reason: '起因',
    handler: '处理人',
    handle: '处理',
    return_handle: '返回处理',
    handle_success: '处理成功',
    data: '数据',
    amount: '数量',
    unknown_error: '未知错误',
    exception: '异常',
    online: '在线',
    offline: '离线',
    // stop: '停止',
    open: '开启',
    close: '关闭',
    alarm_on: '报警开启',
    alarm_off: '报警关闭',
    // 表头
    table_scope: '企业',
    table_customer_code: '企业ID',
    table_contact: '联系人',
    table_phone: '手机/电话号码',
    table_email: '邮箱',
    table_scope_type: '企业类型',
    table_operation: '操作',
    table_arch: '架构',
    table_name: '姓名',
    table_carrier: '资产',
    table_code: '编号',
    table_desc: '描述',
    table_create_time: '创建时间',
    table_carrier_name: '资产名称',

    // 表格操作
    tbopt_delete: '删除',
    tbopt_detail: '详情',
    tbopt_edit: '编辑',
    // 按钮
    btn_confirm: '确认',
    btn_cancel: '取消',
    btn_new: '新增',
    btn_delete: '删除',
    btn_close: '关闭',
    btn_apply: '确认',
    btn_view: '查看',
    btn_delete_all: '全部删除',
    btn_add: '添加',
    create_user: '创建用户',
    btn_yes: '是',
    btn_no: '否',
    yes: '是',
    no: '否',
    filter: '筛选',
    btn_ok: 'OK',
    batchOperation: '批量操作',
    batch_delete: '批量删除',
    relogin_tip: '菜单已更新，系统导航菜单需重新登录后才会刷新，是否立即重新登录？',
    sync_user: '同步用户',
    // 删除成功 失败等统一提示
    tip_del_succ: '删除成功',
    tip_del_fail: '删除失败',
    tip_add_succ: '新增成功',
    tip_modify_succ: '修改成功',
    tip_save_succ: '保存成功',
    tip_oper_succ: '操作成功',
    tip_oper_fail: '操作失败',
    tip_upload_empty: '文件上传不能为空',
    tip_edit_succ: '编辑成功',

    tip_confirm: '您确定要进行此操作吗?',
    // 资产类型模块
    enabled: '启用',
    stop: '停用',
    type_status_disable: '停用',
    // 数据类型
    varchar: '字符串',
    int: '数字',
    double: '小数',
    bigint: '时间',

    icon_desc: '图标代表的含义如下',
    carrier_run_status: '资产运行状态',
    is_abnormal: '是否异常',
    temp: '温度',
    hum: '湿度',
    collect_data: '采集数据',
    sample: '取样',
    reflash: '刷新',
    search: '搜索',
    select_time: '选择日期',
    speed: '速度',
    // status: '状态',
    location: '定位',
    location_desc: '位置',
    group_desc: '群组',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    total_num: '总数',
    running: '运行',
    // offline: '离线',
    // stop: '停用',
    bind: '已绑',
    unbind: '待绑',
    device: '设备',
    device_key_label: '设备 key',
    unconfirm: '待验',
    normal: '正常',
    using: '正在使用',
    operation_record: '操作记录',
    setting: '设置',
    img: '图片',
    temp_range: '温度区间',
    hum_range: '湿度区间',
    temp_val: '温度值',
    hum_val: '湿度值',
    ex_conn: '连接终端',
    ex_temp: '温度异常',
    ex_hum: '湿度异常',
    ex_data: '数值超限',
    ex_power: '断电',
    trigger: '触发器',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日',
    update_time: '更新时间',
    basic_info: '基本信息',
    event: '事件',
    interval: '间隔',
    task: '任务',
    content: '内容',
    check_item: '检测',
    len_max_20: '长度不能超过20',
    len_max_30: '长度不能超过30',
    times: '次',
    previous_next: '上下页',
    calibration: '校准',
    calibration_import: '校准导入',
    verification_task: '验证任务',
    verify_object: '验证对象',
    task_start_time: '任务开始时间',
    task_end_time: '任务结束时间',
    record_start_time: '记录开始时间',
    verify_desc: '验证描述',
    verify_device: '验证设备',
    add_verify_device: '新增验证设备',
    verify_conditions: '验证条件',
    sampling_frequency : '采样频率',
    verify_time: '验证时长',
    calc_result: '计算结果',
    verify_record: '验证记录',
    verify_notice: '验证通知',
    temperature_deviation: '温度偏差',
    humidity_deviation: '湿度偏差',
    temperature_fluctuation: '温度波动度',
    humidity_fluctuation: '湿度波动度',
    temperature_uniformity: '温度均匀度',
    humidity_uniformity: '湿度均匀度',
    recording_after: '符合条件后开始记录',
    recording_start: '任务开始时候立即记录',
    notice_complet: '任务完成时通知',
    notice_timeout: '条件不符合超时通知',
    notice_except: '任务记录时的异常通知',
    timeout_setting: '超时设置',
    data_delay: '数据异常延迟',
    offline_delay: '离线异常延迟',
    verify_device_title: '验证设备称号',
    upload_interval: '上传间隔',
    task_detail: '任务详细展示',
    task_start: '任务启动中',
    data_record: '数据记录中',
    data_compare: '数据对比',
    start_record: '开始记录',
    terminate_task: '终止任务',
    distance_task: '离任务结束',
    are_you_sure_you_want_to_stop_task_q: '你确定要终止任务吗?',
    calibration_expired: '校准过期提示',
    task_time: '任务时间',
    demonstrations: '展示方式',
    taskName: '任务名称',
    to_be_start: '待启动',
    doing: '进行中',
    file_from: '文件生于',
    sun: '日',
    dataDuration: '数据时长',
    effective_anomaly: '有效异常',
    all_anomaly: '全部异常',
    is_store_data: '是否存储数据',
    compare_device: '对比的验证设备',
    compare_start: '进行对比',
    installation_point_num: '安装位置数量',
    data_rate: '数据上报及时/达标率',
    total_info: '总体信息',
    temp_cannot_add_hum: '所选设备存在温度计，不可添加湿度监测区间',
    causes: '导致原因',
    ex_offline: '离线异常',
    device_not_meet: '验证设备当前还没符合条件',
    carrier_data_detail: '资产数据详细',
    data_timely_rate: '数据上报及时率',
    data_standard_rate: '数据上报达标率',
    data_year_on_year: '数据同比',
    create_time: '生成时间',
    file_name: '文件名称',
    repeated_rule_conditions_tips: '每个规则下的规则条件不可重复',
    alarm_detail: '报警详情',
    ex_max_temp_hum: '异常最高温/湿度',
    ex_min_temp_hum: '异常最低温/湿度',
    ex_duration_temp: '温度异常持续最长时间',
    ex_duration_hum: '湿度异常持续最长时间',
    ex_duration_offline: '离线持续最长时间',
    ex_duration_power: '断电持续最长时间',

    copy_right: '版权所有',
    v_mark: '广州景瑞智能科技有限公司',
    reserve_all_rights: '并保留所有权利',
    // 底部栏新版文案
    footer_rights: '版权所有 © 2026 V-Mark Enterprises Ltd. 保留所有权利。',
    footer_address: '地址：加拿大温哥华西百老汇街601号400室，V5Z 4C2',
    footer_privacy: '隐私政策',
    footer_terms: '使用条款',
    total: '总计',
    mode: '模式',
    statistic_preview: '统计预览',
    records_passed: '通过记录数',
    please_select_statistics: '请选择统计',
    use_custom_interval: '使用自定义区间',
    use_default_interval: '使用默认区间',
    passing_rate:'通过占比',
    statistic_object: '资产',
    select_at_least_one_asset: '至少选择一个资产',
    greater_than: '大于',
    less_than: '小于',
    greater_than_equal: '大于等于',
    less_than_equal: '小于等于',
    filter_invalid_info: '过滤无效信息',
    upper_limit: '上限',
    lower_limit: '上限',
    fault_duration_less: '容错时长少于',
    continuous_anomal_less: '连续异常少于',
    abnormal_frequency_less: '异常频率少于',
    reconnection_duration_less:'重连时长少于',
    Power_duration_less: '断电时长少于',
    jump_to_history: '点击跳转到历史',
    no_monitoring_interval_set: '不存在区间',
    click_view_detail_abnormal: '查看事件',
    contact_details: '联系方式详情',
    downloading: '下载中...',
    guide_item_name: '引导项名称',
    guide_code: '引导项编码',
    enter_guide_name: '请输入引导项名称',
    group: '分组',
    delete_group: '删除分组',
    add_group: '新增分组',
    edit_group: '编辑分组',
    curr_group: '当前分组',
    add_guidance_item: '新增引导项',
    edit_guidance_item: '编辑引导项',
    delete_guidance_item: '删除引导项',
    modify_guidance_item_status: '修改引导项状态',
    apply_equipment: '申请设备',
    equipment_maintenance: '设备维护',
    no_monitoring_points: '无关联资产',
    trigger_on: '触发器开启',
    trigger_off: '触发器关闭',
    unrelated_trigger :'未关联触发器',
    work_mode: '工作模式',
    please_select_work_mode: '请选择工作模式',
    gps_switch: 'gps开关',
    switch: '开关',
    go_download_page_view: '请前往下载页面查看',
    Exporting: '导出中',
    Export_successful: '导出成功',
    Is_it_covered: '是否覆盖?',
    Already_exists: '已存在',
    sure_want_to_export: '你确定要导出文件吗?',
    Latest_collected_data_sampling: '最新采集数据取样',
    Latest_collected_data_sampling_desc: '必须有一条关联设备映射记录以上，使用最新的采集数据作为取样数据',
    Maximum_value_data_sampling: '最大值数据取样',
    Maximum_value_data_sampling_desc: '必须有两条关联设备映射记录以上，使用两个或以上映射设备采集回来的数据中最大的数据作为取样数据',
    Minimum_value_data_sampling: '最小值数据取样',
    Minimum_value_data_sampling_desc: '必须有两条关联设备映射记录以上，使用两个或以上映射设备采集回来的数据中最小的数据作为取样数据',
    Avg_value_data_sampling: '平均值数据取样',
    Avg_value_data_sampling_desc: '必须有两条关联设备映射记录以上，使用两个或以上映射设备采集回来的数据取其平均数据作为取样数据',
    Equilibrium_value_data_sampling: '均衡值数据取样',
    Equilibrium_value_data_sampling_desc: '必须有三条关联设备映射记录以上，使用三个或以上映射设备采集回来的数据，剔除最大最小值数据，其余数据进行平均值计算，得出的数据作为取样数据',
    Transport_Code: '运输码',
    Filter_conditions: '过滤条件',
    abnormal_step_desc_1: '在这里可以看到最新的五条异常信息',
    carrier_step_desc_1: '点击此处可对资产的异常进行处理',
    abnormal_more_step_desc_2: '点击more可以查看完整的异常列表',
    abnormal_all_step_desc_3: '也可以在菜单[异常->异常记录]查看完整的异常列表',
    carrier_history_step_desc_1: '点击此处可以查看该资产的历史数据',
    carrier_history_step_desc_2: '资产列表中也可以查看历史数据，点击菜单 资产->任意资产类型',
    go_home: '回到首页',
    click_open_close_alarm: '点击可以打开/关闭报警开关',
    alarm_color_title_1: '报警图标不同颜色代表的含义也不一样',
    alarm_color_red: '红色 --- 报警已关闭',
    alarm_color_green: '绿色 --- 报警已启动',
    alarm_color_gray: '灰色 --- 未设置报警触发器',
    select_monitoring_here: '在此选择资产',
    Carrier_list_desc:'还可以在资产列表(资产->任意资产类型)中打开或关闭报警开关',
    history_desc_2:'还可以在数据看板->资产中查看查看历史数据',
    abnormal_tips: '异常提示',
    sensors_offline_red : '如果该取样内有传感器离线，该图标会置红',
    select_monitoring: '选择资产',
    Open_report_statistics: '打开报表统计',
    Open_report_statistics_detail: '打开报表统计->详细数据',
    set_export_conditions: '设置导出条件',
    set_export_go_download:'设置导出条件后点击导出后即可到下载列表下载',
    download_desc_1: '可在下载菜单中进行导出文件的下载',
    open_carrier_list: '打开资产列表',
    view_transport_Code_desc: '点击此处可展示运输二维码，通过微信扫描即可记录在传感器在运输途中的温度数据,注意：需要当资产为运输模式时才会拥有此图标',
    skip: '跳过',
    next: '下一条',
    previous: '上一条',
    Click_export_desc: '点击导出数据即可导出',
    download_desc_2: '导出后的文件可以在下载页面下载',
    download_data: '下载数据',
    abnormal_info: '异常信息',
    abnormal_handle: '异常处理',
    abnormal_more: '更多异常',
    no_tips: '不再提醒',
    tips_close_success: '关闭引导成功,可以在个人档案处再次开启引导',
    transport_Code_desc_2: '只有当资产的模式为运输模式时才会显示此图标，运输码可提供给微信扫描，以记录运输轨迹和温度变化',
    upload_img_tips1: '上传图⽚只能是 JPG、PNG 格式',
    upload_img_tips2: '上传图⽚⼤⼩不能超过 20MB!',

    table_file_type: '文件类型',
    load: '加载',
    start:'启动',
    revoke:'撤销',

    // 国际化新增
    keep_at_least_one_item: '至少保留一项',
    confirm_delete_item: '你确定要删除该项吗',

  },
  deviceEvent: {
    alarm: '报警事件',
    carry: '资产设备',
    ex: '异常事件',
    point: '安装位置',
    info: '资产信息',
    all: '全部'
  }
}
